import { ChartWidgetDataService } from '@/modules/ta/legacy/widget/services/data/ChartWidgetDataService';

export class PieChartDataService extends ChartWidgetDataService {}
